<template>
  <div
    class="gf-custom-input-number"
    :class="[{ '--error': !!error }, additionalClass]"
  >
    <button
      type="button"
      class="gf-custom-input-number__button --decrement"
      @click="decrement"
      :class="{ '--disabled': isDecrementDisabled }"
    >
      <i class="gf-icon gf-icon-minus"></i>
    </button>
    <input
      v-model="newValue"
      type="text"
      class="gf-custom-input-number__input"
      :placeholder="placeholder"
      :id="id"
      :name="name"
      :min="min"
      :max="max"
      @input="filterValueByRegex"
      :disabled="disabled"
      ref="gfCustomInputNumberInput"
    />
    <button
      type="button"
      class="gf-custom-input-number__button --increment"
      @click="increment"
      :class="{ '--disabled': isIncrementDisabled }"
    >
      <i class="gf-icon gf-icon-plus"></i>
    </button>
  </div>
</template>
<script>
export default {
  name: 'GfCustomInputNumber',
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    min: {
      type: [Number, String],
      default: 1
    },
    max: {
      type: [Number, String],
      default: Number.MAX_SAFE_INTEGER
    },
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    additionalClass: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    isVuePage: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      newValue: Number(this.value)
    };
  },
  watch: {
    newValue: {
      handler: function () {
        this.newValue = Number(this.newValue);
        this.updateValue(Number(this.newValue));
      }
    }
  },
  computed: {
    isIncrementDisabled() {
      return this.newValue == Number(this.max);
    },
    isDecrementDisabled() {
      return this.newValue == Number(this.min);
    }
  },
  mounted() {
    this.updateValue(Number(this.value));
  },
  methods: {
    increment() {
      this.newValue = Math.min(Number(this.newValue) + 1, Number(this.max));
    },
    decrement() {
      this.newValue = Math.max(Number(this.newValue) - 1, Number(this.min));
    },
    filterValueByRegex() {
      const isOnlyDigits = /^\d+$/.test(Number(this.newValue));

      if (!isOnlyDigits) {
        this.newValue = Number(this.newValue.replace(/[^0-9].*$/, ''));
      }

      if (Number(this.newValue) <= Number(this.min)) {
        this.newValue = Number(this.min);
      } else if (Number(this.newValue) > Number(this.max)) {
        this.newValue = Number(this.max);
      }

      this.updateValue(Number(this.newValue));
    },
    updateValue(value) {
      this.$emit('input', Number(value));

      if (!this.isVuePage) {
        this.dispatchInputEventForNonVuePage(value);
      }
    },
    dispatchInputEventForNonVuePage(value) {
      const event = new CustomEvent('GfCustomInputNumberInputEvent', {
        detail: { message: value }
      });
      document.dispatchEvent(event);
    }
  }
};
</script>
<style lang="scss">
$this: '.gf-custom-input-number';

#{$this} {
  // Дефолт
  position: relative;
  display: flex;
  align-items: center;
  width: fit-content;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  transition: color 0.15s ease-in-out, border-color 0.15s ease-in-out;

  // При фокусе на один из элементов (кнопки / инпут)
  &:focus-within {
    border: 1px solid var(--primary);

    #{$this}__button {
      color: var(--primary);
    }
  }

  #{$this}.--error {
    border-color: red !important;
  }

  // Дефолт
  #{$this}__input {
    border: none;
    border-radius: var(--border-radius);
    padding: 5.5px 0;
    text-align: center;

    @include theme.max-md {
      padding: 9.5px 0;
    }
  }

  // Дефолт
  #{$this}__button {
    border: none;
    padding: 8px;
    font-size: 20px;
    background: transparent;
    font-weight: 600;
    color: var(--text);

    @include theme.max-md {
      padding: 10px;
    }

    &.--disabled {
      color: var(--text-muted) !important;
      border-color: var(--border-color) !important;
    }

    &.--decrement {
      position: absolute;
      border-top-left-radius: var(--border-radius);
      border-bottom-left-radius: var(--border-radius);
    }

    &.--increment {
      position: absolute;
      left: calc(100% - 36px);
      border-top-right-radius: var(--border-radius);
      border-bottom-right-radius: var(--border-radius);

      @include theme.max-md {
        left: calc(100% - 42px);
      }
    }
  }
}
</style>
